import { useEffect, useRef } from 'preact/compat';

import { Message } from '../types/message.types';

interface UseAutoScrollOptions {
  messages: Message[];
  isOpen: boolean;
  isLoadingHistory: boolean;
}

export function useAutoScroll({
  messages,
  isOpen,
  isLoadingHistory,
}: UseAutoScrollOptions) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isOpen && !isLoadingHistory) {
      ref.current?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages, isOpen, isLoadingHistory]);

  return ref;
}
